<template>
    <!-- <v-form v-model="isValid"></v-form> -->
    <v-container grid-list-md fluid>
        <v-row no-gutters>
            <v-col
                d-flex
                class="font-weight-bold justify-center"
                style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
            >
                {{ displayExpressionTitle }}
            </v-col>
        </v-row>
        <v-row no-gutters class="pb-2">
            <v-col :cols="_dontAllowCreation ? 12 : 11">
                <v-text-field-filled
                    v-model="searchBar"
                    label="Rechercher"
                    single-line
                    hide-details
                    color="primary"
                    data-cy="choosePersonalisedCard-indicator-search"
                    density="compact"
                    clearable
                    append-inner-icon="$search"
                    @click:clear="searchBar = ''"
                />
            </v-col>
            <v-col cols="1" v-if="!_dontAllowCreation" class="d-flex justify-center">
                <v-btn icon="$add" @click="openIB_GeneratorDialog = true" size="small" />
            </v-col>
        </v-row>
        <v-list subheader lines="two">
            <!-- :style="`overflow-y: auto; height: ${listHeight}`" -->
            <v-list-item
                v-for="(indicator, index) in filteredComputedIndicators"
                :key="index"
                class="oss-list-item mb-2"
                :disabled="indicator.alreadyConnected && definedOperator === 'v1'"
                @click="selection(indicator)"
                :data-cy="'ChoosePersonalisedCard-' + index + '-TypeIndicateur'"
            >
                <template v-slot:append class="my-0">
                    <!-- <v-btn-icon icon="$oss-edit" @click="" /> -->
                    <v-btn-next v-if="CINumberNeeded === 1" />
                    <v-btn-icon
                        v-else
                        :disabled="
                            selectedIndicatorsCompleted &&
                            selectedIndicators.findIndex((e) => e && e.id === indicator.id) === -1
                        "
                        data-cy="ChoosePersonalisedCard-TypeRatio-btn"
                        :icon="
                            selectedIndicators.find((e) => e && e.id === indicator.id)
                                ? '$fa-check-square'
                                : '$fa-square'
                        "
                    />
                    <!-- <v-checkbox-btn v-else v-model="indicator.isSelected"></v-checkbox-btn> -->
                </template>
                <!-- <v-list-item-content class="py-0" data-cy="ChoosePersonalisedCard-TypeIndicateur-list-item-content"> -->
                <v-list-item-title>
                    {{ displayIndicatorName(indicator.definition) }}
                </v-list-item-title>
                <v-list-item-subtitle
                    v-if="indicator.alreadyConnected && definedOperator === 'v1'"
                    class="font-italic"
                >
                    Cet indicateur est déjà affiché
                </v-list-item-subtitle>
                <!-- </v-list-item-content>
                <v-list-item-action class="my-0">
                    <v-btn icon @click >
                        <v-icon color="grey lighten-1">$oss-edit</v-icon>
                    </v-btn>
                    <v-btn icon>
                        <v-icon color="grey lighten-1">chevron_right</v-icon>
                    </v-btn>
                </v-list-item-action> -->
            </v-list-item>
        </v-list>
        <oss-dialog
            v-model="openIB_GeneratorDialog"
            title="Créer un nouvel indicateur"
            :actions="CI_creatorActions"
        >
            <div style="width: 85vw">
                <ComputedIndicatorCreator
                    :companyId="companyId"
                    :actions="CI_creatorActions"
                    @computedIndicatorSavedInBDD="CI_created($event)"
                ></ComputedIndicatorCreator>
            </div>
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

// import PUBLIC_KEYS from '../../graphql/dashboardAccounting/PublicKeys.gql';
import DASHBOARD_INDICATORS from "../../graphql/computedIndicator/GetComputedIndicators.gql";
import { Component, Vue, toNative, Emit } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import ComputedIndicatorCreator from "./ComputedIndicatorCreator.vue";
import { ComputedIndicator } from "../../../../types/types/indexTypes";
import { DialogAction } from "../../services/dialogAction";

interface ComputedIndicatorRule {
    operator: "startsWith" | "equalTo";
    numbers: Array<string>;
    debitOrCredit: "both" | "debitOnly" | "creditOnly";
    notStartsWith: Array<string>;
}

type ComputedIndicatorDef =
    | {
          operator: string;
          values: CI_Value[];
          displayName?: string;
      }
    | any;

type CI_Value = {
    type: "BALANCE";
    balanceRules: string;
    displayName: string;
    operationName: string; // "v1" or "v2" or "v3", etc...
};

@Component({
    components: {
        ComputedIndicatorCreator,
    },
    emits: ["computedIndicatorSelected"],
})
export class ComputedIndicatorSelector extends Vue {
    @Prop() companyId: String; // obligatoire
    @Prop({ default: "v1" }) definedOperator: String; // by default act as "v1"  isRatio: Boolean; // to transform into operationString
    @Prop({ default: ["v1"] }) operatorsWanted: Array<String>;
    @Prop({ default: false }) dontAllowCreation: boolean;
    @Prop({ default: null }) limitationRange: Array<String>;
    @Prop({ default: null }) actions: any;

    searchBar = "";
    CINumberNeeded: number;
    selectedIndicators: Array<ComputedIndicator> = [];
    openIB_GeneratorDialog: boolean = false;
    CI_creatorActions = {
        action: new DialogAction(),
    };

    get filteredComputedIndicators() {
        const result = [];
        if (this.searchBar == "") {
            return this.computedIndicators;
        }
        for (const cIs of this.computedIndicators) {
            if (
                this.displayIndicatorName(cIs.definition)
                    .toLowerCase()
                    .includes(this.searchBar.toLowerCase())
            ) {
                result.push(cIs);
            }
        }
        return result;
    }

    get displayExpressionTitle() {
        //! only works if operatorsWanted === ["v1"] or CINUMBERNEEDED === 1
        if (this.CINumberNeeded === 1) {
            return "";
        }
        let result = this.definedOperator;
        for (let index = 1; index <= this.CINumberNeeded; index++) {
            const replacementText = this.selectedIndicators[index - 1]
                ? this.displayIndicatorName(this.selectedIndicators[index - 1].definition)
                : "";
            result = result.replace("v" + index, replacementText);
        }
        return result;
    }

    get selectedIndicatorsCompleted() {
        if (this.selectedIndicators.length === this.CINumberNeeded) {
            for (const indicator of this.selectedIndicators) {
                if (!indicator?.id) {
                    return false;
                }
            }
            return true;
        }
        return false;
    }

    get _dontAllowCreation() {
        if (this.$store.state.user?.profile?.type === "ACCOUNTING_CLIENT") {
            return false;
        }
        return this.dontAllowCreation;
    }

    get regexp(): RegExp {
        return this.operatorsWanted?.length === 1
            ? new RegExp(this.operatorsWanted[0].replaceAll(/v\d/g, "v\\d"), "g")
            : /v\d/g;
    }
    mounted() {
        if (this.actions) {
            debugger;
            this.actions.action.function = () => {
                this.$emit("computedIndicatorSelected", this.selectedIndicators);
            };
            this.actions.action.disabled = () => {
                return !this.selectedIndicatorsCompleted;
            };
        }
        this.CINumberNeeded = Array.from(this.definedOperator.matchAll(this.regexp)).length;
        this.selectedIndicators = new Array(this.CINumberNeeded).fill(undefined);
        window.addEventListener(
            "resize",
            () => {
                this.windowHeight = window.innerHeight;
            },
            true,
        );
    }

    @Emit("computedIndicatorSelected")
    emitTest(selectedIndicators) {
        return selectedIndicators;
    }

    @Apollo({
        query: DASHBOARD_INDICATORS,
        variables() {
            return {
                companyId: this.companyId,
                operatorsWanted: this.operatorsWanted,
                range: this.limitationRange ? this.limitationRange : undefined,
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading && data) {
                if (data.getComputedIndicators?.computedIndicators) {
                    this.computedIndicators = JSON.parse(
                        JSON.stringify(data.getComputedIndicators.computedIndicators),
                    );
                }
            }
        },
    })
    computedIndicators: any = [];

    displayIndicatorName(computedIndicator: ComputedIndicatorDef): string {
        if (computedIndicator.displayName) {
            return computedIndicator.displayName;
        }
        let result = computedIndicator.operator;
        for (const v of computedIndicator.values) {
            result = result.replace(v.operationName, v.displayName);
        }
        if (result[0] === "-") {
            result = result.replace("-", "");
        }
        return result;
    }

    selection(indicator) {
        if (this.CINumberNeeded > 1) {
            const index = this.selectedIndicators.findIndex(
                (e) => e !== undefined && e.id === indicator.id,
            );
            if (index !== -1) {
                this.selectedIndicators[index] = undefined;
            } else {
                const firstIndexFree = this.selectedIndicators.findIndex((e) => e === undefined);
                if (firstIndexFree !== -1) {
                    if (firstIndexFree < this.CINumberNeeded) {
                        this.selectedIndicators[firstIndexFree] = indicator;
                    }
                }
            }
        } else {
            this.$emit("computedIndicatorSelected", indicator);
        }
    }

    CI_created(indicator) {
        this.openIB_GeneratorDialog = false;
        this.$emit("computedIndicatorSelected", indicator);
    }

    windowHeight = window.innerHeight;

    beforeMount() {
        window.addEventListener(
            "resize",
            () => {
                this.windowHeight = window.innerHeight;
            },
            true,
        );
    }

    get listHeight() {
        debugger;
        let maxHeight = this.windowHeight; //- (28 + 16 * 2);
        // maxHeight -= 68;
        // maxHeight -= 185;
        // maxHeight -= 56;
        const result = `min(${this.computedIndicators.length * 74}px, ${maxHeight}px)`;
        return result; // maxHeight + 'px;'
    }
}

export default toNative(ComputedIndicatorSelector);
</script>
